import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class NavConfig extends BaseOption {
  static label = "Navigation Items";
  orientation = "vertical";

  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.NAVIGATION_CONFIGURATION,
  };

  static defaultValue = "";
}
